
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/[[...url]]",
      function () {
        return require("private-next-pages/service/[[...url]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/[[...url]]"])
      });
    }
  